export default {
  data() {
    return {
      uiTheme1: {
        title: "Business",
        theme: "grey0blue1",
        type: "std",
        size: "med",
        bkgdColor: "wplgrey0",
        bkgdColorSecondary: "#fff",
        btnColor: "wplblue1",
        btnColorGrey: "wplgrey1",
        btnColorWarning: "wplorange0",
        btnColorError: "wplred0",
        btnColorLight: "wplwhite0",
        btnDisabledColor: "wplorange0",
        btnSize: "",
        iconColor: "wplblue1",
        pageColor: "wplblue1",
        iconSize: "",
        chipColor: "wplgrey0",
        chipSize: "",
        cardColor: "wplgrey0",
        cardColorLight: "wplwhite0",
        cardColorPure: "white",
        cardBarColor: "wplgrey0",
        cardMaxWidth: "350",
        cardMaxHeight: "350",
        tileMaxWidth: "250",
        tileMaxHeight: "150",
        sliderColor: "wplblue2",
        textColor: "wplblue1--text",
        textColorError: "wplred0--text",
        textColorWarning: "wplorange0--text",
        textColorWhite: "wplwhite0--text",
        chipColorStd: "wplblue0 wplblue0--text",
        textSize: "",
        textFont: "",
        textWeight: "",
        cardElev1: "elevation-2 wplgrey0",
        textNav: "", // naviagtion bar text
        colorNavigationBar: "wplgrey0",
        textImage: "caption wplgrey1--text mr-2",
        responseShowXs: "xs-only hidden-sm-and-up text-xs-left",
        responseHideXs: "hidden-xs-only",
        sizeWidthDialogSmall: "350px",
        sizeWidthDialogMedium: "400px",
        sizeWidthDialogLarge: "500px",
        sizeWidthDialogExtraLarge: "700px",
        textDisplay2: "display-2 wplblue1--text",
        textDisplay2Light: "display-2 wplwhite0--text",
        textDisplay1: "display-1 wplblue1--text",
        textDisplay1Light: "display-1 wplwhite0--text",
        textHeadline: "headline wplblue1--text",
        textHeadlineWhite: "headline white--text",
        textSubheading: "subheading wplblue1--text",
        textSubheadingGrey: "subheading wplgrey1--text",
        textSubheadingWarning: "subheading wplorange0--text",
        textSubheadingError: "subheading wplred0--text",
        textSubheadingBold: "subheading wplblue1--text font-weight-medium",
        textSubheadingBoldError: "subheading wplred0--text font-weight-medium",
        // eslint-disable-next-line
        textSubheadingBoldWarning: "subheading wplorange0--text font-weight-medium",
        // eslint-disable-next-line
        textSubheadingBoldWhite: "subheading wplwhite0--text font-weight-medium",
        textHeadlineLight: "headline wplwhite0--text",
        textDescription: "body-1 wplgrey1--text",
        textDescriptionBkgd: "body-1 wplgrey0--text",
        textDescriptionBold: "body-1 wplblue1--text font-weight-bold",
        textDescriptionSecondary: "body-1 wplblue1--text font-weight-medium",
        textColorSecondary: "wplblue0--text",
        textDescriptionSuccess: "body-1 wplgreen0--text",
        textDescriptionError: "body-1 wplred0--text",
        textDescriptionWarning: "body-1 wplorange0--text",
        textCard: "body-1 white wplgrey1--text",
        textBlue1: "wplblue1--text",
        textTitle: "title wplblue1--text",
        textTitle2: "title font-weight-thin wplblue1--text",
        textTitleError: "title wplred0--text",
        textWarning: "wplorange0--text",
        textError: "wplred0--text",
        textSuccess: "wplgreen0--text",
        colorBlue1: "wplblue1",
        colorBlue2: "wplblue2",
        colorBlue3: "wplblue3",
        colorGreen2: "wplgreen2",
        colorWarning: "wplorange0",
        colorSuccess: "wplgreen0",
        colorError: "wplred0",
        colorComment: "wplgrey0",
        colorWhite: "wplwhite0",
        colorBlue: "wplblue0"
      }
    };
  }
};
